import script from "./DocumentViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&setup=true&lang=js"

import "./DocumentViewer.vue?vue&type=style&index=0&id=4cb47d98&lang=scss&scoped=true"

import exportComponent from "/builds/pfir/pfir-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb47d98"]])

export default __exports__